import axios from 'axios';

export function postVesselSale(vesselId, { mailId, ideaPrice, salePrice, context, realUserEmail }) {
    return axios({
        method: 'POST',
        url: `/api/v1/vessels/admin/forSale/${vesselId}`,
        data: {
            mailId,
            ideaPrice,
            salePrice,
            context,
            realUserEmail,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getVesselSales({ page, filters }) {
    return axios({
        method: 'POST',
        url: '/api/v1/vessels/admin/forSale',
        data: {
            page: page || 1,
            filters: filters || {},
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteVesselSale(saleId) {
    return axios({
        method: 'delete',
        url: `/api/v1/vessels/admin/forSale/${saleId}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/vessels/sales.js